(function () {
	const initSlider = () => {
		let productSlider;
		const productSliders = document.querySelectorAll('.blog-post-with-icon__swiper');

		productSliders.forEach((slider, index) => {
			productSlider = new Swiper(slider, {
				pagination: {
					el: '.blog__posts__pagination',
					bulletClass: 'swiper-bullet',
					bulletActiveClass: 'swiper-bullet-active',
					clickable: true,
					renderBullet: function(index, className) {
						return '<span class="' + className + ' swiper-bullet--svg-animation"><svg width="30" height="30" viewBox="0 0 28 28"><circle class="svg__circle" style="animation-duration: ' + this.el.getAttribute('data-duration') + 's" cx="14" cy="14" r="12" fill="none" stroke-width="2"></circle></svg></span>';
					}
				},
                navigation: {
					nextEl: ".blog-post-item__button-next",
					prevEl: ".blog-post-item__button-prev",
				},
                slidesPerView: 1.6,
                slidesPerGroup: 1,
                spaceBetween: 8,
                autoplay: true,
                breakpoints: {
				768: {
					slidesPerView: 4,
                    autoplay: false,
				},
                1440: {
					slidesPerView: 6,
				}
			}
			});
		});
	};

	const destroySlider = () => {
		const productSliders = document.querySelectorAll('.blog-post-with-icon__swiper');

		productSliders.forEach((slider, index) => {
			if (slider.swiper !== undefined) slider.swiper.destroy();
		});
	};

	const initSection = () => {
		const sections = document.querySelectorAll('.section__blog-post-with-icon');

		const sectionResizeObserver = new ResizeObserver((entries) => {
			destroySlider();
			initSlider();
		});

		destroySlider();
		initSlider();

		sections.forEach(item => {
			sectionResizeObserver.observe(item);
		});
	};

	initSection();

	document.addEventListener('shopify:section:load', function () {
		initSection();
	});
})();